/* 페이지 관련 시작 */
export const AdminArticlePath = [
  { label: "홈", href: "/admin" },
  { label: "게시글" },
];
export const AdminArticleTitle =
  AdminArticlePath[AdminArticlePath.length - 1].label;
/* 페이지 관련 끝 */

/* 관련 시작 */
export const ArticleStates = [
  { key: "active", value: "활성" },
  { key: "inactive", value: "비활성" },
  { key: "delete", value: "삭제" },
];

export const ArticleState = (state: any) => {
  const object = ArticleStates.find((item) => item.key === state.toString());
  return object?.value ?? state;
};
/* 로그 관련 끝 */
